<template>
    <div ref="scrollTarget"></div>
    <div class="container-fluid" style="height: 100%;">
        <div class="row">
            <main class="col-md-12" style="background-color: #F7F7F8;">
                <div class="row justify-content-center" style="margin-top: 20px; margin-bottom: 100px;">
                    <div class="col-12 text-center">
                        <div class="mb-3" style="max-width: 500px; margin: 0 auto 15px auto;">
                            <input
                                type="text"
                                class="form-control"
                                v-model="filters.search"
                                placeholder="Search by shipment ID, company, or store"
                            />
                        </div>
                        <template v-if="filteredRows.length">
                            <div class="table-responsive-lg">
                                <table class="table table-hover table-striped table-bordered table-responsive">
                                    <thead class="table-dark">
                                        <tr>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff; border-top-left-radius: 12px;">
                                                Shipment ID</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Responsible</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Company</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Store</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Shipment date</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Price total</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Price HTVA</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                TVA %</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                TVA amount</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Agent commission</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Cash to collect</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Envelope</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Paid ?</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff; border-top-right-radius: 12px;">
                                                Edit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row in filteredRows" :key="row.shipment_id">
                                            <td style="vertical-align: middle; text-align: center;">{{ row.shipment_id }}</td>
                                            <td style="vertical-align: middle; text-align: center;">{{ row.responsible_name }}</td>
                                            <td style="vertical-align: middle; text-align: center;">{{ row.company_name }}</td>
                                            <td style="vertical-align: middle; text-align: center;">{{ row.store_name }}</td>
                                            <td style="vertical-align: middle; text-align: center;">{{ row.shipment_date }}</td>
                                            <td style="vertical-align: middle; text-align: center;">{{ row.price_total }}</td>
                                            <td style="vertical-align: middle; text-align: center;">{{ row.price_htva }}</td>
                                            <td style="vertical-align: middle; text-align: center;">{{ row.vat_percent }}</td>
                                            <td style="vertical-align: middle; text-align: center;">{{ row.vat_amount }}</td>
                                            <td style="vertical-align: middle; text-align: center;">{{ row.commission_agent }}</td>
                                            <td style="vertical-align: middle; text-align: center;">{{ row.cash_to_collect }}</td>
                                            <td style="vertical-align: middle; text-align: center;">{{ row.envelope_number }}</td>
                                            <td :class="{ 'green-class': row.is_paid, 'red-class': !row.is_paid }"
                                                style="vertical-align: middle; text-align: center;">
                                                {{ row.is_paid ? 'Paid' : 'Not paid' }}
                                            </td>
                                            <td
                                                style="vertical-align: middle; text-align: center; color: #E5097F; cursor: pointer; text-decoration: underline;">
                                                <span @click="selectRow(row)">{{ translate('see_details') }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                        <template v-else>
                            <div class="container"
                                style="text-align: center; color: white; font-weight: bold; font-size: 1.5em; background-color: #F1A8D0; padding: 60px; border-radius: 20px;">
                                {{ translate('no_orders') }}
                            </div>
                        </template>

                        <div v-if="selectedRow" class="modal">
                            <div class="modal-content">
                                <span style="text-align: right;" @click="closeModal" class="close">&times;</span>
                                <div style="text-align: center;">
                                    <p style="color: #E5097F;">
                                        <strong style="color: #E5097F;">Shipment id :</strong>
                                        {{ selectedRow.shipment_id }}
                                    </p>
                                </div>
                                <div class="modal-body">
                                    <div class="column">
                                        <p>
                                        <div class="row">
                                            <div class="col">
                                                <label class="label-control"
                                                    style="color: black; font-weight: 600; margin-bottom: 5px;">
                                                    Envelope number
                                                </label>
                                                <input type="text" class="form-control" placeholder="Envelope number"
                                                    v-model="selectedRow.envelope_number">
                                            </div>
                                        </div>
                                        </p>
                                        <br>
                                        <p>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox"
                                                v-model="selectedRow.is_paid" id="flexCheckCashPaid">
                                            <label class="form-check-label" for="flexCheckCashPaid">
                                                Paid
                                            </label>
                                        </div>
                                        </p>
                                    </div>
                                    <div class="column">
                                        <p></p>
                                    </div>
                                </div>
                                <div>
                                    <button class="btn btn-success" style="width: 200px;"
                                        @click="confirmUpdate(selectedRow.shipment_id)">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import en from '../en.js';
import fr from '../fr.js';
import nl from '../nl.js';

export default {
    name: 'CashPayments',
    mixins: [en, fr, nl],
    data() {
        return {
            rows: [],
            selectedRow: null,
            filters: {
                search: ""
            },
        }
    },
    computed: {
        lang() {
            return this.$store.state.lang || 'en'
        },
        filteredRows() {
            const term = (this.filters.search || "").toLowerCase();
            if (!term) {
                return this.rows;
            }
            return this.rows.filter((r) => {
                const text = [
                    r.shipment_id,
                    r.company_name,
                    r.store_name,
                    r.responsible_name,
                ]
                    .filter(Boolean)
                    .join(" ")
                    .toLowerCase();
                return text.includes(term);
            });
        },
    },
    async created() {
        this.$store.commit('setIsLoading', true)
        await this.fetchRows()
        this.$store.commit('setIsLoading', false)
    },
    mounted() {
        document.title = 'Dashboard | Cash payments';
        const element = this.$refs.scrollTarget;
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        window.scrollTo(0, 0);
    },
    methods: {
        translate(prop) {
            const currentLang = this.lang || 'en';
            const dict = this[currentLang] || this.en || {};
            return dict[prop] || '';
        },
        async fetchRows() {
            try {
                const response = await axios.post('/api/v1/admin/get-cash-shipments/');
                this.rows = response.data['cash_shipments'] || [];
            } catch (error) {
                console.error('Error fetching cash shipments:', error);
            }
        },
        selectRow(row) {
            // clone to avoid mutating table directly before save
            this.selectedRow = { ...row };
        },
        closeModal() {
            this.selectedRow = null;
            this.fetchRows();
        },
        confirmUpdate(shipmentId) {
            Swal.fire({
                icon: 'question',
                title: 'Update cash payment',
                text: 'Are you sure you want to update this cash payment?',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                confirmButtonColor: '#4BB543',
                cancelButtonColor: '#ff0e0e',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.updateCashShipment(shipmentId)
                }
            });
        },
        async updateCashShipment(shipmentId) {
            if (!this.selectedRow) {
                return;
            }

            const payload = {
                is_paid: this.selectedRow.is_paid,
                envelope_number: this.selectedRow.envelope_number || '',
            };

            this.$store.commit('setIsLoading', true)
            try {
                await axios.post(`/api/v1/admin/update-cash-shipment/${shipmentId}/`, payload);
                await this.fetchRows();
                this.closeModal();
            } catch (error) {
                console.error('Error updating cash shipment:', error);
            }
            this.$store.commit('setIsLoading', false)
        },
    }
}
</script>

<style scoped>
.modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    color: black;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-body {
    display: flex;
    justify-content: space-between;
}

.column {
    width: 50%;
    text-align: left;
}

.modal-content {
    background-color: #FEEEF6;
    margin: 10% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 70%;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.green-class {
    background-color: #13c810;
    color: white;
}

.red-class {
    background-color: #F44336;
    color: white;
}
</style>

